import React, { useState, useEffect } from "react";
import { AnimatePresence, motion } from "framer-motion";
import SRFC from "../../assets/srfc.webp";

const OurClients = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const testimonials = [
    {
      quote:
        "Multify’s reliable solutions and support ensured seamless continuity for our business. A truly invaluable partner!",
      name: "Shri Ram Finance Corporation Private Limited",
      company: "",
      logo: SRFC,
    },
    {
      quote:
        "Multify’s reliable solutions and support ensured seamless continuity for our business. A truly invaluable partner!",
      name: "Shri Ram Finance Corporation Private Limited",
      company: "",
      logo: SRFC,
    },
    {
      quote:
        "Multify’s reliable solutions and support ensured seamless continuity for our business. A truly invaluable partner!",
      name: "Shri Ram Finance Corporation Private Limited",
      company: "",
      logo: SRFC,
    },
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % testimonials.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  return (
    <div className="  py-32 px-4">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-4xl md:text-5xl font-bold text-center text-white mb-4">
          Our Clients
        </h2>
        <p className="text-lg text-center text-gray-300 mb-16">
          Hear firsthand how our solutions have boosted online success for users
          like you.
        </p>

        <div className="relative border-y bo border-white clientBox">
          <AnimatePresence mode="wait">
            <div
              key={currentSlide}
              className="grid md:grid-cols-2 gap-8 items-center"
            >
              {/* Logo Side */}
              <motion.div
                initial={{ opacity: 0, x: 100 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: -100 }}
                transition={{ duration: 0.5 }}
                className="flex justify-center items-center"
              >
                <div
                  className="relative"
                  style={{ width: "60%", height: "60%" }}
                >
                  <img
                    src={testimonials[currentSlide].logo}
                    alt="SRFC"
                    className="w-full h-full object-contain"
                  />
                </div>
              </motion.div>

              {/* Content Side */}
              <motion.div
                initial={{ opacity: 0, x: -100 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: 100 }}
                transition={{ duration: 0.5, delay: 0.2 }}
                className="space-y-6"
              >
                <blockquote className="text-2xl md:text-4xl text-white font-medium">
                  "{testimonials[currentSlide].quote}"
                </blockquote>
                <div className="space-y-2">
                  <h4 className="text-2xl text-gray-300">
                    {testimonials[currentSlide].name}
                  </h4>
                  <p className="text-gray-400">
                    {testimonials[currentSlide].company}
                  </p>
                </div>
              </motion.div>
            </div>
          </AnimatePresence>

          {/* Slide Indicators */}
          <div className="absolute -bottom-12 left-1/2 -translate-x-1/2 flex space-x-3">
            {testimonials.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentSlide(index)}
                className={`w-2 h-2 rounded-full transition-all duration-300 ${
                  currentSlide === index ? "bg-white w-6" : "bg-white/50"
                }`}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default OurClients;
